import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "./Header";
import Footer from "./Footer";
import HomeSeo from "./HomeSeo";
import Slider from "react-slick";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import { Link, NavLink, useNavigate } from "react-router-dom";

function Home() {
  const navigate = useNavigate();
  const settings1 = {
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 1610,
        settings: { slidesToShow: 3, arrows: false, autoplay: true },
      },
      { breakpoint: 776, settings: { slidesToShow: 2, arrows: false } },
      { breakpoint: 550, settings: { slidesToShow: 1 } },
    ],
  };

  const settings2 = {
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 1610,
        settings: { slidesToShow: 2, arrows: false, autoplay: true },
      },
      { breakpoint: 700, settings: { slidesToShow: 2, arrows: false } },
      { breakpoint: 576, settings: { slidesToShow: 1 } },
    ],
  };

  const [smShow, setSmShow] = useState(false);

  useEffect(() => {
    let form = localStorage.getItem("form");
    if (form == "true") {
      setSmShow(false);
    } else {
      setSmShow(true);
    }
  }, []);

  const [form, setform] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    message: "",
  });
  const formsubmit = (e) => {
    e.preventDefault();
    EnquiryNow();
  };

  const handleChange = (e) => {
    let myUser = { ...form };
    myUser[e.target.name] = e.target.value;
    setform(myUser);
  };

  const EnquiryNow = () => {
    const formData = new FormData();
    formData.append("name", form.name);
    formData.append("email", form.email);
    formData.append("phone", form.phone);
    formData.append("service", form.service);
    formData.append("message", form.message);

    axios.post("https://moironix.com/mail.php", formData).then(
      (res) => {
        if (res.status === 200) {
          toast.success(res.data.message);
          navigate("/thank-you");
          setSmShow(false);
          localStorage.setItem("form", "true");
          setform({
            name: "",
            email: "",
            phone: "",
            service: "",
            message: "",
          });
        }
      },
      (error) => {
        if (error.response && error.response.status === 400) {
          toast.error(error.response.data.message);
        }
      }
    );
  };

  return (
    <>
      <HomeSeo />
      <div className="page">
        <Header />
        <section className="ttm-row banner-section ttm-textcolor-white ttm-bg ttm-bgimage-yes bg-img4 overflow-hidden clearfix">
          <div className="ttm-row-wrapper-bg-layer ttm-bg-layer" />
          <div className="bg-image-overlay" />
          <div className="container">
            <div className="row">
              <div className="col-lg-11 text-center m-auto">
                <div className="section-title style4">
                  <div className="title-header">
                    <h2 className="title" data-aos="fade-right">
                      Your Premier Partner
                    </h2>
                    <div className="banner-text">
                      <div className="w-layout-grid grid-24">
                        <p
                          className="text-right pt-60 res-1400-text-center"
                          data-aos="fade-right"
                          data-aos-offset={100}
                          data-aos-easing="ease-in-sine"
                        >
                          We specialize in delivering cutting-edge
                          <br />
                          technology services that streamline
                        </p>
                        <h2
                          className="title position-relative right_20"
                          data-aos="fade-left"
                          data-aos-offset={100}
                          data-aos-easing="ease-in-sine"
                        >
                          for{" "}
                          <div className="ttm-textcolor-skincolor d-inline-block">
                            Website
                          </div>{" "}
                          &amp;
                        </h2>
                      </div>
                    </div>
                    <h2
                      className="title"
                      data-aos="fade-right"
                      data-aos-offset={100}
                      data-aos-easing="ease-in-sine"
                    >
                      <div className="ttm-textcolor-skincolor d-inline-block">
                        Mobile App
                      </div>{" "}
                      Solutions.
                    </h2>
                  </div>
                </div>
                <div
                  className="banner-buttons text-center res-991-mb-0 res-575-mt-0 res-575-mb-0 mt-50 mb-40"
                  data-aos="fade-left"
                  data-aos-offset={100}
                  data-aos-easing="ease-in-sine"
                >
                  <NavLink
                    className="ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-fill ttm-btn-color-gradiant mr-20 mb-20 res-991-mb-10 d-inline-block"
                    onClick={() => {
                      setSmShow(true);
                    }}
                  >
                    Get Started
                  </NavLink>
                  <p className=" d-inline-block text-left">
                    operations, enhance security, Partner with us for seamless
                    <br />
                    growth and tech-driven success.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="site-main">
          <section
            className="prt-row service-section clearfix"
            data-aos="fade-up"
            data-aos-offset={200}
            data-aos-duration={300}
            data-aos-once="true"
          >
            <div className="container">
              <div className="row align-items-center">
                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12">
                  <div className="section-title res-991-mb-0">
                    <div className="title-header">
                      <h1 className="title ">
                        Best Software Company in Hyderabad
                      </h1>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12">
                  <div className="process-desc pl-90 res-1199-pl-0">
                    <p className="desc-text">
                      Innovative, scalable, and user-friendly software tailored
                      to your business needs. Backed by top-notch security and
                      dedicated support for seamless operations.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row row-equal-height prt-vertical_sep style1 mt-25 res-991-mt-0">
                <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                  <div className="featured-icon-box style1 first-child">
                    <div className="featured-icon-thumnail">
                      <img
                        src="images/icon-01.png"
                        loading="lazy"
                        alt="Icon"
                        className="rotate-img img-fluid"
                      />
                    </div>
                    <div className="featured-content">
                      <h3 className="featured-title-h3">
                        <NavLink to="/about" className="featured-title-h3-link">
                          Expertise in Website Development
                        </NavLink>
                      </h3>
                      <div className="featured-bottom-btn">
                        <Link to="/about" className="btn btn-inline" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                  <div className="featured-icon-box style1 border-none">
                    <div className="featured-icon-thumnail">
                      <img
                        src="images/icon-02.png"
                        loading="lazy"
                        alt="Icon"
                        className="rotate-img img-fluid"
                      />
                    </div>
                    <div className="featured-content">
                      <h3 className="featured-title-h3">
                        <NavLink to="/about" className="featured-title-h3-link">
                          Advanced Software Solutions
                        </NavLink>
                      </h3>
                      <div className="featured-bottom-btn">
                        <Link to="/about" className="btn btn-inline" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                  <div className="featured-icon-box style1 res-991-pl-0">
                    <div className="featured-icon-thumnail">
                      <img
                        src="images/icon-03.png"
                        loading="lazy"
                        alt="Icon"
                        className="rotate-img img-fluid"
                      />
                    </div>
                    <div className="featured-content">
                      <h3 className="featured-title-h3">
                        <NavLink to="/about" className="featured-title-h3-link">
                          Seamless System Integration
                        </NavLink>
                      </h3>
                      <div className="featured-bottom-btn">
                        <Link to="/about" className="btn btn-inline" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                  <div className="featured-icon-box style1 last-child">
                    <div className="featured-icon-thumnail">
                      <img
                        src="images/icon-04.png"
                        loading="lazy"
                        alt="Icon"
                        className="rotate-img img-fluid"
                      />
                    </div>
                    <div className="featured-content">
                      <h3 className="featured-title-h3">
                        <Link to="/about" className="featured-title-h3-link">
                          Reliable Technical Support
                        </Link>
                      </h3>
                      <div className="featured-bottom-btn">
                        <Link to="/about" className="btn btn-inline" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="prt-row padding_zero-section prt-bg bg-base-grey z-index-0 clearfix">
            <div className="container">
              <div className="row">
                <div className="col-xl-6 col-lg-6">
                  <div className="prt-bg prt-col-bgimage-yes col-bg-img-one spacing-9">
                    <div className="prt-col-wrapper-bg-layer prt-bg-layer" />
                    <div className="layer-content" />
                  </div>
                  <img
                    className="img-fluid prt-equal-height-image w-100 position-relative"
                    src="images/bg-image/moironixabout.jpeg"
                    alt="bg-image"
                  />
                </div>
                <div className="col-xl-6 col-lg-6">
                  <div className="prt-bg bg-base-grey spacing-1">
                    <div className="prt-col-wrapper-bg-layer prt-bg-layer">
                      <div className="prt-col-wrapper-bg-layer-inner" />
                    </div>
                    <div className="layer-content">
                      <div className="position-relative">
                        <div className="section-title">
                          <div className="title-header">
                            <h2 className="section-title-h2">
                              Our goal is to provide you with software solutions
                            </h2>
                          </div>
                          <div className="title-desc">
                            <p>
                              At Moironix Soft Solutions, we are passionate
                              about delivering cutting-edge technology solutions
                              that drive business success. Founded with a vision
                              to empower businesses through digital
                              transformation, we specialize in website
                              development, mobile application development, and
                              custom software solutions. Our commitment to
                              quality, innovation, and client satisfaction sets
                              us apart in the competitive landscape of IT
                              services.
                            </p>
                          </div>
                        </div>
                        <div className="row row-equal-height mt-10">
                          <div className="col-lg-6">
                            <div className="featured-box-main">
                              <h3 className="featured-box-h3">
                                Seamless Integration
                              </h3>
                              <div className="prt-horizontal_sep mt-30 mb-30 border-none res-991-mb-15 res-991-mt-15" />
                              <h3 className="featured-box-h3">
                                Smart Automation
                              </h3>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="featured-box-main">
                              <h3 className="featured-box-h3">
                                Top-notch Security
                              </h3>
                              <div className="prt-horizontal_sep mt-30 mb-30 border-none res-991-mb-15 res-991-mt-15" />
                              <h3 className="featured-box-h3">
                                Scalable Performance.
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="prt-row padding_zero-section prt-bg bg-base-gradient clearfix">
            <div className="container-fluid p-0">
              <div className="row">
                <div className="col-lg-12">
                  <div className="marquee-block overflow-hidden">
                    <div className="marquee">
                      <div className="marquee-content">
                        <div className="marquee-text">
                          Web Design & Development
                        </div>
                        <div className="marquee-text">
                          Mobile Application Development
                        </div>
                        <div className="marquee-text">
                          Application Development
                        </div>
                        <div className="marquee-text">Digital Marketing</div>
                        <div className="marquee-text">Graphic Designing</div>
                        <div className="marquee-text">
                          Software Maintenance and Support
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="prt-row bg-img1 prt-bgimage-yes prt-bg bg-base-dark project-section clearfix">
            <div className="prt-row-wrapper-bg-layer prt-bg-layer bg-base-dark" />
            <div className="container">
              <div className="row">
                <div className="col-lg-2 col-md-12">
                  <div className="position-relative">
                    <h3 className="row-heading-h3 res-991-pt-0">
                      One <br />
                      Services
                    </h3>
                  </div>
                </div>
                <div className="col-lg-10 col-md-12">
                  <div className="position-relative section-sm res-991-mt-10">
                    <h2 className="row-heading-h2">Delivering top-tier</h2>
                    <h2 className="row-heading-h2 pl-220 res-1199-pl-0 res-991-pl-10">
                      <span className="text-base-skin">services</span>
                    </h2>
                  </div>
                </div>
              </div>
              <div
                className="row mt-50 res-991-mt-50"
                data-aos="fade-up"
                data-aos-offset={200}
                data-aos-duration={300}
                data-aos-once="true"
              >
                <div className="col-lg-6 col-md-6">
                  <div className="service-box style1">
                    <div className="service-box-thumnail">
                      <NavLink to="/website-design-development">
                        <img
                          width={654}
                          height={490}
                          className="img-fluid"
                          src="images/d1.jpeg"
                          loading="lazy"
                          alt="image"
                        />
                      </NavLink>
                    </div>
                    <div className="service-box-content">
                      <h3 className="service-box-h3">
                        <NavLink
                          to="/website-design-development"
                          className="service-box-link"
                        >
                          Web Design &amp; Development
                        </NavLink>
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="service-box style1">
                    <div className="service-box-thumnail">
                      <NavLink to="/mobile-application-development">
                        <img
                          width={654}
                          height={490}
                          className="img-fluid"
                          src="images/d2.jpeg"
                          loading="lazy"
                          alt="image"
                        />
                      </NavLink>
                    </div>
                    <div className="service-box-content">
                      <h3 className="service-box-h3">
                        <NavLink
                          to="/mobile-application-development"
                          className="service-box-link"
                        >
                          Mobile Application Development
                        </NavLink>
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="service-box style1">
                    <div className="service-box-thumnail">
                      <NavLink to="/application-development">
                        <img
                          width={654}
                          height={490}
                          className="img-fluid"
                          src="images/d3.jpeg"
                          loading="lazy"
                          alt="image"
                        />
                      </NavLink>
                    </div>
                    <div className="service-box-content">
                      <h3 className="service-box-h3">
                        <NavLink
                          to="/mobile-application-development"
                          className="service-box-link"
                        >
                          Application Development
                        </NavLink>
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="service-box style1">
                    <div className="service-box-thumnail">
                      <NavLink to="/digital-marketing">
                        <img
                          width={654}
                          height={490}
                          className="img-fluid"
                          src="images/d4.jpeg"
                          loading="lazy"
                          alt="image"
                        />
                      </NavLink>
                    </div>
                    <div className="service-box-content">
                      <h3 className="service-box-h3">
                        <NavLink
                          to="/digital-marketing"
                          className="service-box-link"
                        >
                          Digital Marketing
                        </NavLink>
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="service-box style1">
                    <div className="service-box-thumnail">
                      <NavLink to="/graphic-design">
                        <img
                          width={654}
                          height={490}
                          className="img-fluid"
                          src="images/d5.jpeg"
                          loading="lazy"
                          alt="image"
                        />
                      </NavLink>
                    </div>
                    <div className="service-box-content">
                      <h3 className="service-box-h3">
                        <NavLink
                          to="/graphic-design"
                          className="service-box-link"
                        >
                          Graphic Design
                        </NavLink>
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="service-box style1">
                    <div className="service-box-thumnail">
                      <NavLink to="/software-maintenance">
                        <img
                          width={654}
                          height={490}
                          className="img-fluid"
                          src="images/d6.jpeg"
                          loading="lazy"
                          alt="image"
                        />
                      </NavLink>
                    </div>
                    <div className="service-box-content">
                      <h3 className="service-box-h3">
                        <NavLink
                          to="/software-maintenance"
                          className="service-box-link"
                        >
                          Software Maintenance & Support
                        </NavLink>
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="prt-row step-section clearfix">
            <div className="container">
              <div className="row">
                <div className="col-xl-7 col-lg-7 col-md-12 col-sm-12">
                  <div className="section-title style2">
                    <div className="title-header section-sm">
                      <h2>Our work</h2>
                      <h2 className="pl-150 res-1199-pl-0 res-991-pl-10">
                        process
                      </h2>
                    </div>
                  </div>
                </div>
                <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12">
                  <div className="process-desc">
                    <p className="desc-text">
                      Well aware of the existing mobile app market trends to
                      keep tabs on the evolving trend of the industry, to
                      developing high-grade app and manage quality at the top
                      positions standard.
                    </p>
                    <div className="mt-35 res-991-mt-15">
                      <NavLink
                        className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-fill prt-btn-color-gradiant"
                        to="/about"
                      >
                        Learning Working Process
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="row"
                data-aos="fade-up"
                data-aos-offset={200}
                data-aos-duration={300}
                data-aos-once="true"
              >
                <div className="col-lg-12">
                  <div className="prt-horizontal_sep mt-85 mb-40 res-991-mt-40" />
                  <div className="prt-processbox-wrapper">
                    <div className="row">
                      <div className="col-lg-5">
                        <div className="prt-box-content">
                          <div className="prt-hovertext1">
                            <div className="process-num">
                              <div className="numbers">Step 1</div>
                            </div>
                          </div>
                          <div className="prt-hovertext2">
                            <div className="process-num">
                              <div className="numbers">Step 1</div>
                            </div>
                          </div>
                          <div className="prt-box-content-title res-991-pt-0">
                            <h3 className="prt-box-title-h3">
                              Discovery & Planning
                            </h3>
                            <p>
                              Gather requirements, define objectives, and create
                              a roadmap for execution.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-7">
                        <div className="prt-box-image res-991-mt-15">
                          <img
                            width={965}
                            height={240}
                            className="proces-img img-fluid"
                            src="images/step1.png"
                            loading="lazy"
                            alt="images"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="prt-horizontal_sep mt-25 mb-40" />
                  <div className="prt-processbox-wrapper">
                    <div className="row">
                      <div className="col-lg-7">
                        <div className="prt-box-image">
                          <img
                            width={965}
                            height={240}
                            className="proces-img img-fluid"
                            src="images/step2.png"
                            loading="lazy"
                            alt="images"
                          />
                        </div>
                      </div>
                      <div className="col-lg-5">
                        <div className="prt-box-content res-991-mt-15">
                          <div className="prt-hovertext1">
                            <div className="process-num">
                              <div className="numbers">Step 2</div>
                            </div>
                          </div>
                          <div className="prt-hovertext2">
                            <div className="process-num">
                              <div className="numbers">Step 2</div>
                            </div>
                          </div>
                          <div className="prt-box-content-title res-991-pt-0">
                            <h3 className="prt-box-title-h3">
                              Development & Implementation
                            </h3>
                            <p>
                              Build, integrate, and deploy the solution while
                              ensuring alignment with project goals.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="prt-horizontal_sep mt-25 mb-40 res-991-mt-0 res-991-mb-35" />
                  <div className="prt-processbox-wrapper">
                    <div className="row">
                      <div className="col-lg-5">
                        <div className="prt-box-content">
                          <div className="prt-hovertext1">
                            <div className="process-num">
                              <div className="numbers">Step 3</div>
                            </div>
                          </div>
                          <div className="prt-hovertext2">
                            <div className="process-num">
                              <div className="numbers">Step 3</div>
                            </div>
                          </div>
                          <div className="prt-box-content-title res-991-pt-0">
                            <h3 className="prt-box-title-h3">
                              Testing & Optimization
                            </h3>
                            <p>
                              Conduct quality assurance, refine performance, and
                              ensure long-term maintainability.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-7">
                        <div className="prt-box-image res-991-mt-15">
                          <img
                            width={965}
                            height={240}
                            className="proces-img img-fluid"
                            src="images/step3.jpg"
                            loading="lazy"
                            alt="images"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="prt-row bg-img2 prt-bgimage-yes prt-bg bg-base-dark testimonial-section clearfix">
            <div className="prt-row-wrapper-bg-layer prt-bg-layer bg-base-dark" />
            <div className="container-fluid">
              <div className="row align-items-center spacing-2">
                <div className="col-lg-3">
                  <div className="pr-20 res-1199-pr-0">
                    <div className="prt-custom-counter-content">
                      <h3 className="prt-custom-heading counter is-visible">
                        1000+
                      </h3>
                      <h3 className="custom-heading-h3">Happy Clients</h3>
                    </div>
                    <div className="prt-custom-counter-desc">
                      <p className="counter-desc-p">
                        Our satisfied clients have the best words for our
                        applications.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-9 res-991-mt-20">
                  <div className="row row-equal-height slick_slider">
                    <Slider {...settings2}>
                      <div className="col-lg-4 testimonials-main">
                        <div className="testimonials-style1">
                          <div className="testimonials-style1-content">
                            <div className="testimonial-prt-description">
                              <div className="prt-box-highlight">
                                <h3 className="prt-box-highlight-h3">
                                  Exceeded Our Expectations!
                                </h3>
                              </div>
                              <div className="prt-ratting-stars">
                                <ul className="ratting-stars">
                                  <li className="ratting-stars-items">
                                    <a href="#" className="ratting-stars-link">
                                      <i
                                        className="fa fa-star"
                                        aria-hidden="true"
                                      />
                                    </a>
                                  </li>
                                  <li className="ratting-stars-items">
                                    <a href="#" className="ratting-stars-link">
                                      <i
                                        className="fa fa-star"
                                        aria-hidden="true"
                                      />
                                    </a>
                                  </li>
                                  <li className="ratting-stars-items">
                                    <a href="#" className="ratting-stars-link">
                                      <i
                                        className="fa fa-star"
                                        aria-hidden="true"
                                      />
                                    </a>
                                  </li>
                                  <li className="ratting-stars-items">
                                    <a href="#" className="ratting-stars-link">
                                      <i
                                        className="fa fa-star"
                                        aria-hidden="true"
                                      />
                                    </a>
                                  </li>
                                  <li className="ratting-stars-items">
                                    <a href="#" className="ratting-stars-link">
                                      <i
                                        className="fa fa-star"
                                        aria-hidden="true"
                                      />
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="testimonial-prt-box-desc">
                              <p className="testimonial-prt-box-desc-p">
                                The application streamlined our operations
                                beyond what we imagined. The intuitive design
                                and powerful features have been a game-changer.
                              </p>
                            </div>
                            <div className="prt-box-footer">
                              <h3 className="testimonial-caption-h3">
                                – Sravan M
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 testimonials-main">
                        <div className="testimonials-style1">
                          <div className="testimonials-style1-content">
                            <div className="testimonial-prt-description">
                              <div className="prt-box-highlight">
                                <h3 className="prt-box-highlight-h3">
                                  Game-Changer for Our Business
                                </h3>
                              </div>
                              <div className="prt-ratting-stars">
                                <ul className="ratting-stars">
                                  <li className="ratting-stars-items">
                                    <a href="#" className="ratting-stars-link">
                                      <i
                                        className="fa fa-star"
                                        aria-hidden="true"
                                      />
                                    </a>
                                  </li>
                                  <li className="ratting-stars-items">
                                    <a href="#" className="ratting-stars-link">
                                      <i
                                        className="fa fa-star"
                                        aria-hidden="true"
                                      />
                                    </a>
                                  </li>
                                  <li className="ratting-stars-items">
                                    <a href="#" className="ratting-stars-link">
                                      <i
                                        className="fa fa-star"
                                        aria-hidden="true"
                                      />
                                    </a>
                                  </li>
                                  <li className="ratting-stars-items">
                                    <a href="#" className="ratting-stars-link">
                                      <i
                                        className="fa fa-star"
                                        aria-hidden="true"
                                      />
                                    </a>
                                  </li>
                                  <li className="ratting-stars-items">
                                    <a href="#" className="ratting-stars-link">
                                      <i
                                        className="fa fa-star"
                                        aria-hidden="true"
                                      />
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="testimonial-prt-box-desc">
                              <p className="testimonial-prt-box-desc-p">
                                The transition to this application was smooth,
                                and our team adapted quickly. It saves us hours
                                of work every week.
                              </p>
                            </div>
                            <div className="prt-box-footer">
                              <h3 className="testimonial-caption-h3">
                                – Santhosh T
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 testimonials-main">
                        <div className="testimonials-style1">
                          <div className="testimonials-style1-content">
                            <div className="testimonial-prt-description">
                              <div className="prt-box-highlight">
                                <h3 className="prt-box-highlight-h3">
                                  Reliable and Scalable Solution
                                </h3>
                              </div>
                              <div className="prt-ratting-stars">
                                <ul className="ratting-stars">
                                  <li className="ratting-stars-items">
                                    <a href="#" className="ratting-stars-link">
                                      <i
                                        className="fa fa-star"
                                        aria-hidden="true"
                                      />
                                    </a>
                                  </li>
                                  <li className="ratting-stars-items">
                                    <a href="#" className="ratting-stars-link">
                                      <i
                                        className="fa fa-star"
                                        aria-hidden="true"
                                      />
                                    </a>
                                  </li>
                                  <li className="ratting-stars-items">
                                    <a href="#" className="ratting-stars-link">
                                      <i
                                        className="fa fa-star"
                                        aria-hidden="true"
                                      />
                                    </a>
                                  </li>
                                  <li className="ratting-stars-items">
                                    <a href="#" className="ratting-stars-link">
                                      <i
                                        className="fa fa-star"
                                        aria-hidden="true"
                                      />
                                    </a>
                                  </li>
                                  <li className="ratting-stars-items">
                                    <a href="#" className="ratting-stars-link">
                                      <i
                                        className="fa fa-star"
                                        aria-hidden="true"
                                      />
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="testimonial-prt-box-desc">
                              <p className="testimonial-prt-box-desc-p">
                                This software grows with our business needs. Its
                                robust features and excellent support make it a
                                perfect choice.
                              </p>
                            </div>
                            <div className="prt-box-footer">
                              <h3 className="testimonial-caption-h3">
                                – Murthi p
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 testimonials-main">
                        <div className="testimonials-style1">
                          <div className="testimonials-style1-content">
                            <div className="testimonial-prt-description">
                              <div className="prt-box-highlight">
                                <h3 className="prt-box-highlight-h3">
                                  Boosted Our Productivity
                                </h3>
                              </div>
                              <div className="prt-ratting-stars">
                                <ul className="ratting-stars">
                                  <li className="ratting-stars-items">
                                    <a href="#" className="ratting-stars-link">
                                      <i
                                        className="fa fa-star"
                                        aria-hidden="true"
                                      />
                                    </a>
                                  </li>
                                  <li className="ratting-stars-items">
                                    <a href="#" className="ratting-stars-link">
                                      <i
                                        className="fa fa-star"
                                        aria-hidden="true"
                                      />
                                    </a>
                                  </li>
                                  <li className="ratting-stars-items">
                                    <a href="#" className="ratting-stars-link">
                                      <i
                                        className="fa fa-star"
                                        aria-hidden="true"
                                      />
                                    </a>
                                  </li>
                                  <li className="ratting-stars-items">
                                    <a href="#" className="ratting-stars-link">
                                      <i
                                        className="fa fa-star"
                                        aria-hidden="true"
                                      />
                                    </a>
                                  </li>
                                  <li className="ratting-stars-items">
                                    <a href="#" className="ratting-stars-link">
                                      <i
                                        className="fa fa-star"
                                        aria-hidden="true"
                                      />
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="testimonial-prt-box-desc">
                              <p className="testimonial-prt-box-desc-p">
                                Since implementing this software, our workflow
                                has become more streamlined, and our
                                productivity has skyrocketed.
                              </p>
                            </div>
                            <div className="prt-box-footer">
                              <h3 className="testimonial-caption-h3">
                                – Ravi K
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Slider>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="prt-row blog-section clearfix">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-xl-8 col-lg-6 col-md-12 col-sm-12">
                  <div className="blog-title text-end">
                    <div className="section-title style2">
                      <div className="title-header">
                        <h2>
                          Stay up <span />
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-6 col-md-12 col-sm-12 blog-sm">
                  <div className="process-desc process-desc1">
                    <p className="desc-text">
                      Web designing in a powerful way of just not a profession,
                      how in a passion for our Company. We have a to the idea.
                    </p>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-3 col-md-12 col-sm-12 blog-sm">
                  <div className="blog-title text-end mt-15">
                    <NavLink
                      className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-fill prt-btn-color-gradiant"
                      to="/blog"
                    >
                      Upcoming News!
                    </NavLink>
                  </div>
                </div>
                <div className="col-xl-8 col-lg-9 col-md-12 col-sm-12">
                  <div className="section-title style2 mt-25 res-991-mt-0 res-991-mt_5">
                    <div className="title-header">
                      <h2>to date</h2>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row slick_slider mt-10">
                <Slider {...settings1}>
                  <div className="col-lg-4">
                    <div className="featured-imagebox-post-style1">
                      <div className="featured-post-overlay">
                        <div className="featured-post-thumbnail">
                          <img
                            className="img-fluid w-auto"
                            style={{ height: "414px", width: "447px" }}
                            src="images/bl1.png"
                            loading="lazy"
                            alt="image"
                          />
                        </div>
                        <div className="featured-post-content">
                          <div className="post-entry-date">10 Jan 2025</div>
                          <div className="prt-post-title">
                            <h3 className="post-h3">
                              <NavLink to="blog-details" className="post-link">
                                The Future of Software Development: A High-Tech
                                Vision ?
                              </NavLink>
                            </h3>
                          </div>
                          <div className="prt-post-catagory">
                            <div className="catagory-text">By _Vikas</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="featured-imagebox-post-style1">
                      <div className="featured-post-overlay">
                        <div className="featured-post-thumbnail">
                          <img
                            className="img-fluid w-auto"
                            style={{ height: "414px", width: "447px" }}
                            src="images/bl2.png"
                            loading="lazy"
                            alt="image"
                          />
                        </div>
                        <div className="featured-post-content">
                          <div className="post-entry-date">20 Jan 2025</div>
                          <div className="prt-post-title">
                            <h3 className="post-h3">
                              <NavLink to="blog-details" className="post-link">
                                The Developer’s Workspace: Immersed in Code ?
                              </NavLink>
                            </h3>
                          </div>
                          <div className="prt-post-catagory">
                            <div className="catagory-text">By _Srinivas</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="featured-imagebox-post-style1">
                      <div className="featured-post-overlay">
                        <div className="featured-post-thumbnail">
                          <img
                            className="img-fluid w-auto"
                            style={{ height: "414px", width: "447px" }}
                            src="images/bl3.png"
                            loading="lazy"
                            alt="image"
                          />
                        </div>
                        <div className="featured-post-content">
                          <div className="post-entry-date">03 Jan 2050</div>
                          <div className="prt-post-title">
                            <h3 className="post-h3">
                              <NavLink to="blog-details" className="post-link">
                                Agile Development in Action: Team Collaboration
                              </NavLink>
                            </h3>
                          </div>
                          <div className="prt-post-catagory">
                            <div className="catagory-text">By _Gopal</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Slider>
              </div>
            </div>
          </section>
        </div>
        <Footer />
        <Modal
          size="md"
          show={smShow}
          onHide={() => setSmShow(false)}
          className="mt-5"
          aria-labelledby="example-modal-sizes-title-sm"
        >
          <div className="prt-col-bgcolor-yes bg-base-dark text-base-white col-bg-img-seven prt-col-bgimage-yes prt-bg">
            <div className="prt-col-wrapper-bg-layer prt-bg-layer bg-base-dark">
              <div className="prt-col-wrapper-bg-layer-inner bg-base-dark" />
            </div>
            <div className="layer-content map-contect-form">
              <div className="section-title">
                <div className="title-header">
                  <div
                    style={{
                      float: "right",
                    }}
                  >
                    <h5
                      onClick={() => {
                        setSmShow(false);
                      }}
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="Close"
                      className="closeicon"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-x-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
                      </svg>
                    </h5>
                  </div>
                  <h2 className="title">
                    <h4>
                      Welcome to
                      <span style={{ color: "#05C8F9" }}>
                        {" "}
                        Moironix Soft Solutions
                      </span>
                    </h4>
                  </h2>
                </div>
              </div>
              <form
                onSubmit={(e) => {
                  formsubmit(e);
                }}
                method="post"
                className="query_form wrap-form clearfix mt-25 res-991-mt-0 position-relative"
              >
                <div className="row">
                  <div className="col-md-12">
                    <label>
                      <span className="text-input">
                        <input
                          type="text"
                          name="name"
                          value={form.name}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          required
                          placeholder="Your Name"
                        />
                      </span>
                    </label>
                  </div>
                  <div className="col-md-12">
                    <label>
                      <span className="text-input">
                        <input
                          required
                          type="email"
                          name="email"
                          placeholder="Your Email"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          value={form.email}
                        />
                      </span>
                    </label>
                  </div>
                  <div className="col-md-12">
                    <label>
                      <span className="text-input">
                        <input
                          required
                          type="text"
                          name="phone"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          maxlength="10"
                          minLength="10"
                          pattern="[0-9]{10}"
                          value={form.phone}
                          placeholder="Your Mobile Number"
                          onKeyPress={(e) => {
                            // Allow only numeric input
                            const charCode = e.which ? e.which : e.keyCode;
                            if (charCode < 48 || charCode > 57) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </span>
                    </label>
                  </div>
                  <div className="col-md-12">
                    <label>
                      <span className="text-input">
                        <input
                          required
                          type="text"
                          name="service"
                          placeholder="Enter Service"
                          list="service-options"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          value={form.service}
                        />
                      </span>
                      <datalist id="service-options">
                        <option value="Application Development" />
                        <option value="Web Design & Development" />
                        <option value="Mobile Application Development" />
                        <option value="Digital Marketing" />
                        <option value="Software Maintenance & Support" />
                      </datalist>
                    </label>
                  </div>
                  <div className="col-md-12">
                    <label>
                      <span className="text-input">
                        <textarea
                          name="message"
                          rows={3}
                          placeholder="Message"
                          type="text"
                          value={form.message}
                          onChange={(e) => {
                            handleChange(e);
                          }}
                        />
                      </span>
                    </label>
                  </div>
                  <div className="col-md-12">
                    <div className="mt-25">
                      <button
                        className="prt-btn prt-btn-size-md prt-btn-shape-round prt-btn-style-fill prt-btn-color-gradiant w-100"
                        type="submit"
                      >
                        Schedule a Meeting
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
}

export default Home;
